var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.254 26.6667H8V24.635C8 23.2878 8.53515 21.9959 9.48771 21.0433C10.4403 20.0907 11.7322 19.5556 13.0794 19.5556H19.1746C20.5217 19.5556 21.8137 20.0907 22.7663 21.0433C23.7188 21.9959 24.254 23.2878 24.254 24.635V26.6667ZM16.127 17.5239C15.3265 17.5239 14.5339 17.3662 13.7944 17.0599C13.0549 16.7536 12.383 16.3046 11.817 15.7386C11.251 15.1726 10.802 14.5007 10.4957 13.7612C10.1894 13.0217 10.0317 12.2291 10.0317 11.4286C10.0317 10.6282 10.1894 9.83557 10.4957 9.09607C10.802 8.35656 11.251 7.68462 11.817 7.11863C12.383 6.55263 13.0549 6.10366 13.7944 5.79735C14.5339 5.49103 15.3265 5.33337 16.127 5.33337C17.7435 5.33337 19.2939 5.97555 20.437 7.11863C21.58 8.26171 22.2222 9.81205 22.2222 11.4286C22.2222 13.0452 21.58 14.5955 20.437 15.7386C19.2939 16.8817 17.7435 17.5239 16.127 17.5239Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5632ebc1a5a3cea78c8cb83213a97fa0.svg";
export { ForwardRef as ReactComponent };